import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const Container = styled(FlexContainer)`
  display: flex;
  width: 375px;
  padding: ${({ theme: { system } }) => `0 ${system.fds_sys_spacing_S}`};
`;

export const ProgressContainer = styled.div`
  width: 100px;
`;
